var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgBackMovil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 518,
    viewBox: "0 0 480 518",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10523_6879)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 1448,
    fill: "#FFFAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.07 299.619C361.462 292.276 347.277 297.37 347.277 297.37C347.277 297.37 346.821 296.796 345.907 295.935C342.926 293.113 335.088 287.301 322.899 289.477C307.031 292.3 303.184 304.833 303.184 304.833C303.184 304.833 291.139 299.642 279.238 305.837C267.337 312.032 267.89 322.747 267.89 322.747C239.544 320.499 235 347 235 347H417C415.197 338.987 411.11 333.056 406.566 328.703C398.319 320.81 388.654 318.227 388.654 318.227C388.654 318.227 388.654 306.937 375.046 299.619H375.07Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip1_10523_6879)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.970131 216.242H86.2664V493.773H-0.970131V216.242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.970043 216.242H42.6482V493.003H-0.970043V216.242Z",
    fill: "#FFFAE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5077 189H76.3066V216.242H45.5077V189Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4956 189H52.8408V216.242H45.4956V189Z",
    fill: "#FFFAE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.542 216.242V214.655H-3.51532V216.242",
    fill: "#FFD62B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6736 228.131H69.0537V243.764H61.6736V228.131Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6481 249.889C42.6481 250.053 52.4108 250.193 64.4514 250.193C76.4921 250.193 86.2664 250.064 86.2664 249.889C86.2664 249.714 76.5037 249.586 64.4514 249.586C52.3992 249.586 42.6481 249.714 42.6481 249.889Z",
    fill: "#FFD62B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 228.131H25.0518V243.764H17.6716V228.131Z",
    fill: "#FFD62B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34188 249.889C-1.34188 250.053 8.4208 250.193 20.4614 250.193C32.5021 250.193 42.2764 250.064 42.2764 249.889C42.2764 249.714 32.5137 249.586 20.4614 249.586C8.40918 249.586 -1.34188 249.714 -1.34188 249.889Z",
    fill: "#FFD62B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 259.164H25.0518V274.798H17.6716V259.164Z",
    fill: "#FFD62B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34188 280.922C-1.34188 281.086 8.4208 281.226 20.4614 281.226C32.5021 281.226 42.2764 281.097 42.2764 280.922C42.2764 280.747 32.5137 280.619 20.4614 280.619C8.40918 280.619 -1.34188 280.747 -1.34188 280.922Z",
    fill: "#FFD62B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 291.132H25.0518V306.765H17.6716V291.132Z",
    fill: "#FFD62B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34188 312.89C-1.34188 313.054 8.4208 313.194 20.4614 313.194C32.5021 313.194 42.2764 313.065 42.2764 312.89C42.2764 312.715 32.5137 312.587 20.4614 312.587C8.40918 312.587 -1.34188 312.715 -1.34188 312.89Z",
    fill: "#FFD62B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 323.099H25.0518V338.732H17.6716V323.099Z",
    fill: "#FFD62B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34188 344.857C-1.34188 345.02 8.4208 345.16 20.4614 345.16C32.5021 345.16 42.2764 345.032 42.2764 344.857C42.2764 344.682 32.5137 344.554 20.4614 344.554C8.40918 344.554 -1.34188 344.682 -1.34188 344.857Z",
    fill: "#FFD62B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 354.144H25.0518V369.777H17.6716V354.144Z",
    fill: "#FFD62B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34188 375.914C-1.34188 376.077 8.4208 376.217 20.4614 376.217C32.5021 376.217 42.2764 376.089 42.2764 375.914C42.2764 375.739 32.5137 375.61 20.4614 375.61C8.40918 375.61 -1.34188 375.739 -1.34188 375.914Z",
    fill: "#FFD62B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 385.329H25.0518V400.963H17.6716V385.329Z",
    fill: "#FFD62B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 416.911H25.0518V432.545H17.6716V416.911Z",
    fill: "#FFD62B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.34188 407.088C-1.34188 407.251 8.4208 407.391 20.4614 407.391C32.5021 407.391 42.2764 407.263 42.2764 407.088C42.2764 406.913 32.5137 406.784 20.4614 406.784C8.40918 406.784 -1.34188 406.913 -1.34188 407.088Z",
    fill: "#FFD62B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6738 259.631H69.054V275.264H61.6738V259.631Z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6483 281.401C42.6483 281.564 52.411 281.704 64.4517 281.704C76.4923 281.704 86.2666 281.576 86.2666 281.401C86.2666 281.226 76.5039 281.098 64.4517 281.098C52.3994 281.098 42.6483 281.226 42.6483 281.401Z",
    fill: "#FFD62B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6736 291.143H69.0537V306.776H61.6736V291.143Z",
    fill: "#FAFAFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6483 312.902C42.6483 313.065 52.411 313.205 64.4517 313.205C76.4923 313.205 86.2666 313.077 86.2666 312.902C86.2666 312.727 76.5039 312.599 64.4517 312.599C52.3994 312.599 42.6483 312.727 42.6483 312.902Z",
    fill: "#FFD62B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6738 322.644H69.054V338.277H61.6738V322.644Z",
    fill: "#FAFAFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6481 344.402C42.6481 344.565 52.4108 344.705 64.4514 344.705C76.4921 344.705 86.2664 344.577 86.2664 344.402C86.2664 344.227 76.5037 344.099 64.4514 344.099C52.3992 344.099 42.6481 344.227 42.6481 344.402Z",
    fill: "#FFD62B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6736 354.144H69.0537V369.777H61.6736V354.144Z",
    fill: "#FAFAFA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6483 375.915C42.6483 376.078 52.411 376.218 64.4517 376.218C76.4923 376.218 86.2666 376.09 86.2666 375.915C86.2666 375.74 76.5039 375.611 64.4517 375.611C52.3994 375.611 42.6483 375.74 42.6483 375.915Z",
    fill: "#FFD62B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6736 385.656H69.0537V401.29H61.6736V385.656Z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6481 407.415C42.6481 407.578 52.4108 407.718 64.4514 407.718C76.4921 407.718 86.2664 407.59 86.2664 407.415C86.2664 407.24 76.5037 407.111 64.4514 407.111C52.3992 407.111 42.6481 407.24 42.6481 407.415Z",
    fill: "#FFD62B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6738 417.156H69.054V432.79H61.6738V417.156Z",
    fill: "#FAFAFA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6295 518H99.7381L100.308 314.355H-28.06L-28.6295 518Z",
    fill: "#FFFAE6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.0601 314.355H36.1179V518.012H-28.0601V314.355Z",
    fill: "#FFD62B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3139 274.257H85.6406V314.344H40.3139V274.257Z",
    fill: "#FFFAE6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3136 274.257H51.1223V314.344H40.3136V274.257Z",
    fill: "#FFD62B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-31.8256 312.011H111V314.344H-31.8256V312.011Z",
    fill: "#FFD62B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0922 331.832H74.959V354.827H64.0922V331.832Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1179 363.858C36.1179 364.103 50.483 364.302 68.2069 364.302C85.9308 364.302 100.296 364.103 100.296 363.858C100.296 363.613 85.9308 363.415 68.2069 363.415C50.483 363.415 36.1179 363.613 36.1179 363.858Z",
    fill: "#FFD62B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.643156 331.832H10.2236V354.827H-0.643156V331.832Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6174 363.857C-28.6174 364.102 -14.2523 364.301 3.47156 364.301C21.1955 364.301 35.5605 364.102 35.5605 363.857C35.5605 363.612 21.1955 363.414 3.47156 363.414C-14.2523 363.414 -28.6174 363.612 -28.6174 363.857Z",
    fill: "#FFFAE6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.643156 377.496H10.2236V400.491H-0.643156V377.496Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6174 409.521C-28.6174 409.766 -14.2523 409.965 3.47156 409.965C21.1955 409.965 35.5605 409.766 35.5605 409.521C35.5605 409.276 21.1955 409.078 3.47156 409.078C-14.2523 409.078 -28.6174 409.276 -28.6174 409.521Z",
    fill: "#FFFAE6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.643156 424.537H10.2236V447.532H-0.643156V424.537Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6174 456.562C-28.6174 456.807 -14.2523 457.006 3.47156 457.006C21.1955 457.006 35.5605 456.807 35.5605 456.562C35.5605 456.317 21.1955 456.119 3.47156 456.119C-14.2523 456.119 -28.6174 456.317 -28.6174 456.562Z",
    fill: "#FFFAE6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.643156 471.578H10.2236V494.573H-0.643156V471.578Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6174 503.604C-28.6174 503.849 -14.2523 504.047 3.47156 504.047C21.1955 504.047 35.5605 503.849 35.5605 503.604C35.5605 503.358 21.1955 503.16 3.47156 503.16C-14.2523 503.16 -28.6174 503.358 -28.6174 503.604Z",
    fill: "#FFFAE6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0922 378.197H74.959V401.193H64.0922V378.197Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1179 410.222C36.1179 410.467 50.483 410.665 68.2069 410.665C85.9308 410.665 100.296 410.467 100.296 410.222C100.296 409.977 85.9308 409.778 68.2069 409.778C50.483 409.778 36.1179 409.977 36.1179 410.222Z",
    fill: "#FFD62B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0922 424.561H74.959V447.556H64.0922V424.561Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1179 456.586C36.1179 456.831 50.483 457.029 68.2069 457.029C85.9308 457.029 100.296 456.831 100.296 456.586C100.296 456.341 85.9308 456.143 68.2069 456.143C50.483 456.143 36.1179 456.341 36.1179 456.586Z",
    fill: "#FFD62B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0922 470.912H74.959V493.907H64.0922V470.912Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1179 502.938C36.1179 503.183 50.483 503.382 68.2069 503.382C85.9308 503.382 100.296 503.183 100.296 502.938C100.296 502.693 85.9308 502.495 68.2069 502.495C50.483 502.495 36.1179 502.693 36.1179 502.938Z",
    fill: "#FFD62B"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M519.731 64C521.543 41.0364 496.323 36.2004 496.323 36.2004C496.323 36.2004 505.928 24.0951 494.511 14.423C483.094 4.75094 472.281 10.1953 472.281 10.1953C472.281 10.1953 474.697 -6.74606 460.26 -12.1904C445.853 -17.6347 435.644 -7.35438 435.644 -7.35438C435.644 -7.35438 434.436 -20.0376 414.018 -21.8625C393.601 -23.6874 390.61 -6.74606 390.61 -6.74606C390.61 -6.74606 386.412 -20.0376 368.985 -18.8514C351.557 -17.6348 349.171 1.70941 349.171 1.70941C349.171 1.70941 328.753 -4.34325 318.545 7.76205C308.336 19.8674 313.742 37.3866 313.742 37.3866C294.533 42.2226 296.919 64 296.919 64H519.671H519.731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10523_6879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 1448,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10523_6879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 366,
    fill: "white",
    transform: "matrix(-1 0 0 1 111 152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBackMovil);
export default __webpack_public_path__ + "static/media/imgBackMovil.e2214d9f47d31da36c0656c7d6aaae7c.svg";
export { ForwardRef as ReactComponent };